"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _validators = require("./validators.js");

var _validators2 = _interopRequireDefault(_validators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (question, onChangeAnswer, backupAnswer) => {
  const {
    validators = [],
    defaultAnswer = backupAnswer
  } = question;
  const [state, changeState] = (0, _react.useState)({
    answer: defaultAnswer,
    error: null
  });
  return [state, newAnswer => {
    for (const validator of validators) {
      if (!(0, _validators2.default)(validator, newAnswer)) {
        changeState({
          answer: newAnswer,
          error: validator.text || "Invalid input, please correct!"
        });
        return;
      }
    }

    const isNumeric = validators.map(v => v.type).includes("numeric");

    if (typeof newAnswer === "string" && isNumeric) {
      onChangeAnswer(parseFloat(newAnswer));
    } else {
      onChangeAnswer(newAnswer);
    }

    changeState({
      answer: newAnswer,
      error: null
    });
  }];
};